// Лежит ли игрок мёртвым в момент `t`: смерти — `[момент, сколько лежал]`.
export const isDeadAt = (deaths: readonly (readonly [number, number])[], t: number): boolean =>
  deaths.some(([at, length]) => t >= at && t < at + length);
